import { FileType, FILE_TYPES } from '../constants/file-types.constant';

export type FileTypeConfig = {
  showClientColumn: boolean;
  showClientIdentifier: boolean;
  insurerIdentifierDisabled: boolean;
  insurerIdentifierValue: string | null;
  insurerIdentifierPlaceholder: string;
  insurerIdentifierLabel: string;
  clientColumnRequired: boolean;
  clientIdentifierRequired: boolean;
  insurerIdentifierRequired: boolean;
  getMetadata: (formData: {
    clientIdentifier: string;
    clientColumn: string;
    insurerIdentifier: string;
  }) => {
    clientIdentifier?: string;
    clientColumn?: string;
    insurerIdentifier?: string;
  };
};

const {
  SINGLE_CLIENT_SINGLE_INSURER,
  SINGLE_CLIENT_MULTI_INSURER,
  MULTI_CLIENT_SINGLE_INSURER,
  MULTI_CLIENT_MULTI_INSURER,
} = FILE_TYPES;

export const FILE_TYPE_CONFIG: Record<FileType, FileTypeConfig> = {
  [SINGLE_CLIENT_SINGLE_INSURER]: {
    showClientColumn: false,
    showClientIdentifier: true,
    insurerIdentifierDisabled: false,
    insurerIdentifierValue: null,
    insurerIdentifierPlaceholder: 'e.g., BCBS, Anthem',
    insurerIdentifierLabel: 'Insurer Identifier *',
    clientColumnRequired: false,
    clientIdentifierRequired: true,
    insurerIdentifierRequired: true,
    getMetadata: formData => ({
      clientIdentifier: formData.clientIdentifier,
      ...(formData.insurerIdentifier && {
        insurerIdentifier: formData.insurerIdentifier,
      }),
    }),
  },
  [SINGLE_CLIENT_MULTI_INSURER]: {
    showClientColumn: false,
    showClientIdentifier: true,
    insurerIdentifierDisabled: true,
    insurerIdentifierValue: 'multi',
    insurerIdentifierPlaceholder: 'Auto-set to multi',
    insurerIdentifierLabel: 'Insurer Identifier',
    clientColumnRequired: false,
    clientIdentifierRequired: true,
    insurerIdentifierRequired: false,
    getMetadata: formData => ({
      clientIdentifier: formData.clientIdentifier,
      insurerIdentifier: 'multi',
    }),
  },
  [MULTI_CLIENT_SINGLE_INSURER]: {
    showClientColumn: true,
    showClientIdentifier: false,
    insurerIdentifierDisabled: false,
    insurerIdentifierValue: null,
    insurerIdentifierPlaceholder: 'e.g., BCBS, Anthem',
    insurerIdentifierLabel: 'Insurer Identifier *',
    clientColumnRequired: true,
    clientIdentifierRequired: false,
    insurerIdentifierRequired: true,
    getMetadata: formData => ({
      clientColumn: formData.clientColumn,
      clientIdentifier: 'multi',
      ...(formData.insurerIdentifier && {
        insurerIdentifier: formData.insurerIdentifier,
      }),
    }),
  },
  [MULTI_CLIENT_MULTI_INSURER]: {
    showClientColumn: true,
    showClientIdentifier: false,
    insurerIdentifierDisabled: true,
    insurerIdentifierValue: 'multi',
    insurerIdentifierPlaceholder: 'Auto-set to multi',
    insurerIdentifierLabel: 'Insurer Identifier',
    clientColumnRequired: true,
    clientIdentifierRequired: false,
    insurerIdentifierRequired: false,
    getMetadata: formData => ({
      clientColumn: formData.clientColumn,
      clientIdentifier: 'multi',
      insurerIdentifier: 'multi',
    }),
  },
};

export const getFileTypeConfig = (
  fileType: FileType | undefined,
): FileTypeConfig => {
  if (!fileType) {
    return FILE_TYPE_CONFIG[FILE_TYPES.SINGLE_CLIENT_SINGLE_INSURER];
  }
  return FILE_TYPE_CONFIG[fileType];
};

export const isMultiClientFileType = (fileType: FileType): boolean =>
  fileType === MULTI_CLIENT_SINGLE_INSURER ||
  fileType === MULTI_CLIENT_MULTI_INSURER;

export const isSingleClientFileType = (fileType: FileType): boolean =>
  fileType === SINGLE_CLIENT_SINGLE_INSURER ||
  fileType === SINGLE_CLIENT_MULTI_INSURER;
